var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-select-dropdown',{attrs:{"open":_vm.open,"header-text":_vm.headerText,"dropdown-class":_vm.dropdownClass,"items":_vm.items,"initial-checked":_vm.initialChecked},on:{"change":_vm.$listeners.change,"cancel":_vm.$listeners.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }